import { ALWAYS_VISIBLE_MODULES, ClubModuleKey } from '~/components/Layout/ModulePageLayout/clubModules.generated';

/**
 * Module visibility is the fourth navigation axis, next to requiredPlan, permissions
 * and experimental features.
 *
 * ⚠️ It is NOT access control. It hides modules, it does not lock them: the route stays
 * reachable, the API stays open and the data stays put. Permissions grant access,
 * visibility creates order. Anything using this for authorization is a security bug —
 * the real gates are the server-side permission checks and <CheckSubscription>.
 */

/**
 * Decides whether a module should appear in the navigation.
 *
 * `null` or `undefined` means the club never configured a list and therefore sees
 * everything — the state of every existing customer, and also the state while the
 * setting is still loading. An empty array is explicitly different: it means "only the
 * always-visible modules", so a club can narrow down without locking itself out.
 */
export const isModuleVisible = (visible: string[] | null | undefined, key: string | undefined): boolean => {
    if (visible === null || visible === undefined) return true;
    if (!key) return true;
    if ((ALWAYS_VISIBLE_MODULES as readonly string[]).includes(key)) return true;

    return visible.includes(key);
};

/**
 * Whether the club hides anything at all — used to decide if the "show all modules"
 * escape hatch needs to be rendered.
 */
export const hasHiddenModules = (visible: string[] | null | undefined, keys: (string | undefined)[]): boolean =>
    keys.some((key) => !isModuleVisible(visible, key));

export type { ClubModuleKey };
